import { render, staticRenderFns } from "./commonDormStatus.vue?vue&type=template&id=30775a18&scoped=true"
import script from "./commonDormStatus.vue?vue&type=script&lang=js"
export * from "./commonDormStatus.vue?vue&type=script&lang=js"
import style0 from "./commonDormStatus.vue?vue&type=style&index=0&id=30775a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30775a18",
  null
  
)

export default component.exports